import { useTranslation } from 'react-i18next';
import Button from 'components/button/Button';
import useOrderViewFetchedData from '../../useOrderViewFetchedData';
import useAdditionalChargeModal from './useAdditionalChargeModal';

const AdditionalChargeButton = () => {
  const { openAdditionalChargeModal } = useAdditionalChargeModal();
  const {
    lead,
    // @ts-expect-error TS2339 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    initData: { additionalChargeAllowed },
  } = useOrderViewFetchedData();
  const { t } = useTranslation();

  if (!additionalChargeAllowed) {
    return null;
  }

  const onClick = () => {
    // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    openAdditionalChargeModal({ lead });
  };

  return (
    <Button
      bsStyle="link"
      data-testid="additional-charge-button"
      onClick={onClick}
    >
      {t('pageOrder.transactions.actions.additionalCharge.buttonLabel')}
    </Button>
  );
};

export default AdditionalChargeButton;
